export const getInitials = (nombre: string, fallback: string): string => {
  if (!nombre) return fallback;
  const words = nombre.trim().split(/\s+/).filter(Boolean);

  if (words.length === 0) return fallback;

  if (words.length === 1) {
    return words[0][0]?.toUpperCase() || fallback;
  }

  const first = words[0][0]?.toUpperCase() ?? "";
  const last = words[words.length - 1][0]?.toUpperCase() ?? "";
  return `${first}${last}` || fallback;
};

export const authorizationTagLabels: Record<string, string> = {
  employee: "Empleado",
  visit: "Visita",
  contractor: "Contratista",
  eventual: "Eventual",
  preauthorized: "Preautorizado",
  guard: "Autorizado en portería",
  transport: "Transporte",
  companion: "Acompañante",
};

/** Los valores son `BadgeTypes`. `teal` queda reservado para transporte: es el único tag que no
 * describe el tipo de autorización sino el tipo de acceso, así que conviene que se distinga.
 * `companion` tampoco describe una autorización — es el rol dentro del ingreso — y comparte fila
 * con `transport`, así que lleva el otro color libre (`brown`) para no confundirse con ninguno de
 * los tipos ni con el gris del tag desconocido. */
export const authorizationTagVariant: Record<string, string> = {
  employee: "blue",
  visit: "green",
  contractor: "purple",
  eventual: "orange",
  preauthorized: "yellow",
  guard: "blue",
  transport: "teal",
  companion: "brown",
};
